import { createFileRoute } from "@tanstack/react-router";
import Service from "@/pages/Service";

const TITLE = "RV Service & Repair in Wilmington NC | Rex & Sons RVs";
const DESCRIPTION =
  "Certified RV service and repair in Castle Hayne, NC. Roof and sealant work, appliance repair, brakes, bearings, warranty service and seasonal maintenance.";
const URL = "https://www.rexandsonsrvs.com/rv-service";
const IMAGE = "https://www.myrvpart.com/images/splash-assets/hero-service-1920.webp";

export const Route = createFileRoute("/rv-service")({
  component: Service,
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:type", content: "website" },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:url", content: URL },
      { property: "og:image", content: IMAGE },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: DESCRIPTION },
      { name: "twitter:image", content: IMAGE },
    ],
    links: [{ rel: "canonical", href: URL }],
  }),
});
